/**
 * Etiqueta VISIBLE del discriminador interno de tipo de entidad / módulo.
 *
 * El código, los datos y el ruteo siguen usando el literal **"SO"** (entidad/tipo/
 * modulo, `entidadRef`, deep links, auditoría, permisos). Esta función mapea
 * ÚNICAMENTE lo que se muestra al usuario: "SO" → "OT". El resto de los tipos
 * se muestran tal cual. Usar solo en la capa de presentación (nunca para lógica).
 *
 * Ver memoria/decisión: la UI dice "OT" pero internamente la entidad es "so"/"SO".
 */
const ETIQUETA_TIPO: Record<string, string> = {
  SO: "OT",
};

/** Devuelve la etiqueta visible de un discriminador de tipo/módulo. */
export function etiquetaTipo(tipo: string | null | undefined): string {
  if (tipo == null) return "";
  return ETIQUETA_TIPO[tipo] ?? tipo;
}
